/* Cart promo block toggler. */
(function () {
  'use strict';

  // Guard against duplicate script loads (snippet + layout both shipping it).
  if (window.__winelyCartPromoLoaded) return;
  window.__winelyCartPromoLoaded = true;

  var LS_PROMO_CODE    = 'winely_promo_code';
  var LS_PROMO_PENDING = 'winely_promo_pending';

  function log() {}

  function hasClaimedPromo() {
    try {
      return !!localStorage.getItem(LS_PROMO_CODE)
          || localStorage.getItem(LS_PROMO_PENDING) === '1';
    } catch (e) {
      return false;
    }
  }

  function formatEuro(cents) {
    // Round up to the next whole euro — copywriter-approved phrasing wants
    // "€13 away", not "€12,84 away".
    var euros = Math.ceil(Math.max(0, cents) / 100);
    return '€' + euros;
  }

  // [hidden] attribute can be overridden by CSS display:flex on the same
  // element. Belt-and-braces: set inline style + attribute together.
  function show(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    el.style.display = '';
  }
  function hide(el) {
    if (!el) return;
    el.setAttribute('hidden', '');
    el.style.setProperty('display', 'none', 'important');
  }

  function refresh(root, cart) {
    if (!root) return;
    var pendingNode = root.querySelector('[data-cart-promo-pending]');
    var activeNode  = root.querySelector('[data-cart-promo-active]');

    var subtotal    = parseInt(root.dataset.cartSubtotalCents, 10) || 0;
    var threshold   = parseInt(root.dataset.giftMinCents, 10) || 0;
    var locale      = root.dataset.locale || 'en';
    var hasDiscount = root.dataset.hasActiveDiscount === '1';

    log('refresh() input', {
      cartArg: !!cart,
      serverHasDiscount: hasDiscount,
      serverSubtotalCents: subtotal,
      threshold: threshold,
      liquidDebug: {
        total_discount: root.dataset.debugTotalDiscount,
        discount_apps_size: root.dataset.debugDiscountAppsSize,
        discount_apps_titles: root.dataset.debugDiscountAppsTitles,
        discount_apps_amounts: root.dataset.debugDiscountAppsAmounts,
        cart_level_apps_size: root.dataset.debugCartLevelAppsSize,
        original_total: root.dataset.debugOriginalTotal,
        total: root.dataset.debugTotal
      }
    });

    if (cart && typeof cart.original_total_price === 'number') {
      subtotal = cart.original_total_price;
      root.dataset.cartSubtotalCents = String(subtotal);
      var apps = cart.cart_level_discount_applications || [];
      var liveDiscount = false;
      for (var i = 0; i < apps.length; i++) {
        if (apps[i] && apps[i].total_allocated_amount > 0) { liveDiscount = true; break; }
      }
      if (!liveDiscount && cart.total_discount > 0) liveDiscount = true;
      hasDiscount = liveDiscount;
      root.dataset.hasActiveDiscount = liveDiscount ? '1' : '0';
      log('refresh() merged cart.js', {
        total_discount: cart.total_discount,
        original_total_price: cart.original_total_price,
        total_price: cart.total_price,
        cart_level_discount_applications: apps,
        discount_codes: cart.discount_codes,
        liveDiscount: liveDiscount
      });
    }

    var remaining    = Math.max(0, threshold - subtotal);
    var thresholdMet = subtotal >= threshold;
    var hasClaim     = hasClaimedPromo();

    if (hasDiscount) {
      show(activeNode);
    } else {
      hide(activeNode);
    }

    // Show pending banner only to visitors who already claimed a welcome
    // code (LS marker set by the popup or magic link). Without a code in
    // the cart Shopify won't apply the discount even when the threshold
    // is met, so promising the gift to unsubscribed visitors would be a
    // lie. The popup is the entry point for everyone else.
    var shouldShowPending = hasClaim && !hasDiscount && !thresholdMet && remaining > 0;
    if (shouldShowPending) {
      var remainingNode = pendingNode && pendingNode.querySelector('[data-cart-promo-remaining]');
      if (remainingNode) remainingNode.textContent = formatEuro(remaining);
      show(pendingNode);
    } else {
      hide(pendingNode);
    }

    var anyVisible =
      (activeNode && !activeNode.hasAttribute('hidden')) ||
      (pendingNode && !pendingNode.hasAttribute('hidden'));
    if (anyVisible) show(root); else hide(root);

    log('refresh() decision', {
      subtotalCents: subtotal,
      threshold: threshold,
      remaining: remaining,
      thresholdMet: thresholdMet,
      hasDiscount: hasDiscount,
      hasClaim: hasClaim,
      activeHidden: activeNode ? activeNode.hasAttribute('hidden') : 'no-node',
      pendingHidden: pendingNode ? pendingNode.hasAttribute('hidden') : 'no-node',
      wrapperHidden: root.hasAttribute('hidden')
    });
  }

  function refreshAll(cart) {
    var roots = document.querySelectorAll('[data-cart-promo]');
    log('refreshAll() found nodes=' + roots.length);
    roots.forEach(function (root) { refresh(root, cart); });
  }

  var inflight = null;
  function refetch() {
    if (inflight) return inflight;
    log('refetch() /cart.js');
    inflight = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) refreshAll(cart); })
      .catch(function (err) { log('refetch error', err && err.message); })
      .finally(function () { inflight = null; });
    return inflight;
  }

  function init() {
    log('init()');
    refreshAll(null);
    refetch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart drawer is rendered by Alpine and the promo block can appear
  // (and re-appear) in the DOM long after our initial scan — re-evaluate
  // whenever a [data-cart-promo] root shows up via mutation.
  if (typeof MutationObserver === 'function') {
    var seenRoots = new WeakSet();
    var observer = new MutationObserver(function (mutations) {
      var newRoot = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!(node instanceof Element)) continue;
          if (node.matches && node.matches('[data-cart-promo]') && !seenRoots.has(node)) {
            seenRoots.add(node); newRoot = true;
          } else if (node.querySelector) {
            var inner = node.querySelector('[data-cart-promo]');
            if (inner && !seenRoots.has(inner)) { seenRoots.add(inner); newRoot = true; }
          }
        }
      }
      if (newRoot) {
        log('observer detected new [data-cart-promo] root');
        refreshAll(null);
        refetch();
      }
    });
    function startObserver() {
      if (!document.body) {
        document.addEventListener('DOMContentLoaded', startObserver);
        return;
      }
      observer.observe(document.body, { childList: true, subtree: true });
      // Catch nodes that were already present before observer started.
      document.querySelectorAll('[data-cart-promo]').forEach(function (n) { seenRoots.add(n); });
      log('observer attached');
    }
    startObserver();
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) refreshAll(cart); else refetch();
  });

  // Patch window.fetch so /cart/{change,add,update}.js triggers a re-evaluate.
  (function patchFetch() {
    var origFetch = window.fetch;
    if (typeof origFetch !== 'function' || origFetch.__winelyCartPromoPatched) return;
    var wrapped = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = /\/cart\/(change|add|update)(\.js)?(\?|$)/.test(url);
      var p = origFetch.apply(this, arguments);
      if (isCartMutation) {
        p.then(function () { setTimeout(refetch, 50); }, function () {});
      }
      return p;
    };
    wrapped.__winelyCartPromoPatched = true;
    window.fetch = wrapped;
  })();

  window.addEventListener('storage', function (e) {
    if (e.key === LS_PROMO_CODE || e.key === LS_PROMO_PENDING) refetch();
  });
})();
